export default class WebElement {
    constructor(component) {
        this.boundingClientRect = () => {
            return new Promise(resolve => {
                const rect = this.component._rendered.dom.getBoundingClientRect();
                resolve(rect);
            });
        };
        this.component = component;
    }
}
